var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgUnExpectedError = function SvgUnExpectedError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 142 105"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#002A3A",
    d: "M34.172 39a5.5 5.5 0 0 1 5.5-5.5h64a5.5 5.5 0 0 1 5.5 5.5v43a4.5 4.5 0 0 1-4.5 4.5h-66a4.5 4.5 0 0 1-4.5-4.5V39Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#002A3A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M117.835 82.867v1.535c0 1.72-1.535 3.255-3.256 3.255H28.032c-1.72 0-3.256-1.534-3.256-3.255v-1.535h93.059Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#002A3A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M124.079 87.781H17.919"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#002A3A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M80.212 82.867v.558c0 .977-.744 1.907-1.907 1.907H64.12c-.977 0-1.907-.744-1.907-1.907v-.558h17.998Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#002A3A",
    d: "M105.672 82.568h-68V42.016a5 5 0 0 1 5-5h58a5 5 0 0 1 5 5v40.552Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#002A3A",
    d: "M41.797 41.476c.559 0 1.024-.465 1.024-1.023 0-.558-.465-1.023-1.023-1.023-.559 0-1.024.465-1.024 1.023 0 .558.465 1.023 1.023 1.023ZM44.82 41.476c.558 0 1.023-.465 1.023-1.023 0-.558-.465-1.023-1.023-1.023-.558 0-1.023.465-1.023 1.023 0 .558.465 1.023 1.023 1.023Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M47.936 41.476c.558 0 1.023-.465 1.023-1.023 0-.558-.465-1.023-1.023-1.023-.558 0-1.023.465-1.023 1.023 0 .558.465 1.023 1.023 1.023Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#002A3A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M114.589 70.818a3.326 3.326 0 0 1-3.326 3.273H49.798a6 6 0 0 1-6-6V30.363a6 6 0 0 1 6-6h58.791a6 6 0 0 1 6 6v40.455Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    stroke: "#002A3A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M43.798 31.91h70.632"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#002A3A",
    d: "M47.652 29.38c.633 0 1.161-.528 1.161-1.162 0-.633-.528-1.214-1.161-1.214-.634 0-1.162.528-1.162 1.161 0 .634.528 1.214 1.162 1.214ZM51.082 29.38c.634 0 1.162-.528 1.162-1.162 0-.633-.528-1.214-1.162-1.214-.633 0-1.161.528-1.161 1.161 0 .634.528 1.214 1.161 1.214ZM54.62 29.38c.634 0 1.162-.528 1.162-1.162 0-.633-.528-1.214-1.162-1.214-.633 0-1.161.528-1.161 1.161 0 .634.475 1.214 1.161 1.214Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#002A3A",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M74.283 46.481a2.192 2.192 0 1 1-4.385 0 2.192 2.192 0 0 1 4.385 0ZM87.164 46.481a2.192 2.192 0 1 1-4.385 0 2.192 2.192 0 0 1 4.385 0Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#002A3A",
    stroke: "#002A3A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M84.18 60.314H72.882c-1.794 0-2.797-2.006-1.742-3.484a9.605 9.605 0 0 1 2.957-2.692 9.105 9.105 0 0 1 4.434-1.161c1.9 0 3.642.58 5.12 1.583.898.634 1.69 1.373 2.323 2.27 1.003 1.478 0 3.484-1.794 3.484Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#002A3A",
    d: "M82.49 60.314h-7.865a.336.336 0 0 1 0-.317 4.176 4.176 0 0 1 3.959-2.798 4.176 4.176 0 0 1 3.959 2.798c0 .106 0 .211-.053.317Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M83.652 55.088v.422a.529.529 0 0 1-.528.528h-8.447a.529.529 0 0 1-.528-.528v-.845a9.104 9.104 0 0 1 4.435-1.161c1.847 0 3.59.58 5.068 1.584Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#00AFFF",
    d: "M58.933 45.634c0 1.09-.837 1.962-1.883 1.962-1.047 0-1.884-.872-1.884-1.962 0-.828 1.13-3.314 1.633-4.404.083-.218.376-.218.502 0 .502 1.047 1.632 3.532 1.632 4.404ZM54.664 50.482c0 1.048-.782 1.887-1.758 1.887-.977 0-1.758-.839-1.758-1.887 0-.797 1.054-3.187 1.523-4.235.078-.21.352-.21.469 0 .469 1.048 1.524 3.438 1.524 4.235Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF9500",
    d: "M103.994 16.762h9.859c.604 0 1.163.232 1.581.65l6.976 6.977c.419.418.651.976.651 1.58v9.814c0 .604-.232 1.162-.651 1.58l-6.883 6.884a2.214 2.214 0 0 1-1.581.65h-9.952a2.217 2.217 0 0 1-1.582-.65l-7.069-7.07a2.215 2.215 0 0 1-.65-1.58V25.97c0-.605.232-1.163.65-1.581l7.023-6.976c.465-.419 1.023-.651 1.628-.651Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.552 22.363v4.667c0 .311 0 .622-.047.978l-.512 3.334a.597.597 0 0 1-.604.489h-1.023c-.279 0-.558-.223-.605-.49l-.511-3.333c-.047-.311-.047-.622-.047-.978v-4.667c0-.311.279-.578.605-.578h2.185c.28.045.559.267.559.578ZM109.993 38.854h-2.279a.715.715 0 0 1-.697-.698v-2.279c0-.372.325-.697.697-.697h2.279c.372 0 .698.325.698.697v2.28a.716.716 0 0 1-.698.697Z"
  })));
};
export default SvgUnExpectedError;